// extracted by mini-css-extract-plugin
export var component = "HeaderLogo-module--component--VGGmd";
export var link = "HeaderLogo-module--link--yBClF";